import _slicedToArray from "@babel/runtime/helpers/slicedToArray"; // external dependencies

import React from 'react';
// components
import { NearYou } from './NearYou'; // hooks

import { useScript } from '@jelly/utils';
export function InteractiveMap(_ref) {
  var guid = _ref.guid,
      services = _ref.services;

  var _useScript = useScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyCw_OXsa0pC3ZB5SiEfxWEQMawa0TjL32w&libraries=places'),
      _useScript2 = _slicedToArray(_useScript, 2),
      loaded = _useScript2[0],
      error = _useScript2[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, loaded && !error && /*#__PURE__*/React.createElement(NearYou, {
    guid: guid,
    services: services
  }));
}